import { secureApiCall } from "./authHeader";

const API_URL = process.env.REACT_APP_BACKEND_URL;

if (!API_URL) {
  console.error("Error: REACT_APP_BACKEND_URL no está definido.");
}


export const createCLientes = async (clientesData) => {
    try {
        const requestPayload = {
            body: {
                dni: clientesData.dni,
                telefono: clientesData.telefono,
                correo: clientesData.correo,
                codigoCliente: clientesData.codigoCliente,
                consentimiento1: clientesData.consentimiento1,
                consentimiento2: clientesData.consentimiento2,
                operadorId: clientesData.operadorId,
                captcha: clientesData.captcha,
                mensaje: "",
                token: "",
                //utm
                URL_UTM: clientesData.URL_UTM,
                UTM_SOURCE: clientesData.UTM_SOURCE,
                UTM_MEDIUM: clientesData.UTM_MEDIUM,
                UTM_CAMPAIGN: clientesData.UTM_CAMPAIGN,
                UTM_TERM: clientesData.UTM_TERM,
                UTM_CONTENT: clientesData.UTM_CONTENT
            }
        };


        const response = await secureApiCall("api/v1/Clientes/Crear", "post", requestPayload);
        return response;

    } catch (error) {
        console.error('Error en crearCliente:', error);
        throw error;
    }
};